import { Modal } from "antd";

const ModalLoadingOverlay = ({ busy = false, message = "" }) => {
    return busy ? (
        <Modal open={busy} footer={null} closable={false} maskClosable={false} keyboard={false} modalRender={() => (message ? <div className="flex items-center justify-center">{message}</div> : <></>)} />
    ) : (
        <></>
    );
};

export default ModalLoadingOverlay;
